import * as actionTypes from './actionTypes';
import * as actions from './index';

/* NOTIFICATIONS */
export const loadNotificationsStart = () => {
    return {
        type: actionTypes.NOTIFICATION_LOAD_START
    }
};

export const loadNotificationsSuccess = (notifications) => {
    return {
        type: actionTypes.NOTIFICATION_LOAD_SUCCESS,
        notifications: notifications
    }
};

export const loadNotificationsFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_LOAD_FAIL,
        error: error
    }
};

export const loadNotifications = () => {
    return dispatch => {
        dispatch(loadNotificationsStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        if(window.flow.getNotificationsForCurrentUser) {
            window.flow.getNotificationsForCurrentUser().then(res => { 
                dispatch(loadNotificationsSuccess(res.notification.elements));
            }).catch(res => {
                /*
                console.log('getNotifications::catch');
                console.log(res);
                */
                dispatch(loadNotificationsFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
        }
        
    };
};

export const searchNotificationsStart = () => {
    return {
        type: actionTypes.NOTIFICATION_SEARCH_START
    }
};

export const searchNotificationsSuccess = (notifications) => {
    return {
        type: actionTypes.NOTIFICATION_SEARCH_SUCCESS,
        searchNotifications: notifications
    }
};

export const searchNotificationsFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_SEARCH_FAIL,
        error: error
    }
};

export const searchNotifications = (status) => {
    // init default parameter
    const parameter = {};
    // check if status is given
    if (status !== undefined) {
        // add status to parameter object
        parameter['status'] = status;
    }
    console.log('searchNotifications');
    console.log(parameter);
    return dispatch => {
        dispatch(searchNotificationsStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        if(window.flow.getNotificationsForCurrentUser) {
            window.flow.getNotificationsForCurrentUser(parameter).then(res => { 
                console.log('searchNotifications::success');
                console.log(res.notification.elements);
                dispatch(searchNotificationsSuccess(res.notification.elements));
            }).catch(res => {
                /*
                console.log('getNotifications::catch');
                console.log(res);
                */
                dispatch(searchNotificationsFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
        }
        
    };
};

export const addNotificationStart = () => {
    return {
        type: actionTypes.NOTIFICATION_ADD_START
    }
};

export const addNotificationSuccess = (notification) => {
    return {
        type: actionTypes.NOTIFICATION_ADD_SUCCESS,
        payload: {notification: notification}
    }
};

export const addNotificationFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_ADD_FAIL,
        error: error
    }
};

export const addNotification = (notification) => {
    console.log('addNotification');
    console.log(notification);
    return dispatch => {
        dispatch(addNotificationStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        if(window.flow.newNotification) {
            window.flow.newNotification(notification).then(res => { 
                console.log('addNotification::success');
                console.log(res);
                dispatch(addNotificationSuccess(res));
            }).catch(res => {
                /*
                console.log('getNotifications::catch');
                console.log(res);
                */
                dispatch(addNotificationFail(res.message));
            });
        }
        
    };
};

export const setNotificationStart = () => {
    return {
        type: actionTypes.NOTIFICATION_SET_START
    }
};

export const setNotificationSuccess = (notification) => {
    return {
        type: actionTypes.NOTIFICATION_SET_SUCCESS,
        payload: {notification: notification}
    }
};

export const setNotificationFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_SET_FAIL,
        error: error
    }
};

export const setNotification = (id, status) => {
    console.log('setNotification');
    console.log(id, status);
    return dispatch => {
        dispatch(setNotificationStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        if(window.flow.setNotification) {
            window.flow.setNotification(id, status).then(res => { 
                console.log('setNotification::success');
                console.log(res);
                dispatch(setNotificationSuccess(res));
            }).catch(res => {
                /*
                console.log('getNotifications::catch');
                console.log(res);
                */
                dispatch(setNotificationFail(res.message));
            });
        }
        
    };
};


/* APPROVAL USERS */
export const notificationApprovalUserStart = () => {
    return {
        type: actionTypes.NOTIFICATION_APPROVAL_USER_START
    }
};

export const notificationApprovalUserSuccess = (users) => {
    return {
        type: actionTypes.NOTIFICATION_APPROVAL_USER_SUCCESS,
        users: users
    }
};

export const notificationApprovalUserFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_APPROVAL_USER_FAIL,
        error: error
    }
};

export const getNotificationApprovalUser = () => {
    return dispatch => {
        dispatch(notificationApprovalUserStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        if(window.flow.getCurrentUser) {
            window.flow.getCurrentUser().then(res => {
                // load approval users
                const _approval_users = res.g.get('approvalusers');
                /*
                console.log('success user');
                console.log(res);
                console.log(_approval_users);
                */
                // dispatch to success
                dispatch(notificationApprovalUserSuccess(_approval_users));
            }).catch(res => {
                /*
                console.log('fail user');
                console.log(res);
                */
                // dispatch to error
                dispatch(notificationApprovalUserFail(res));
            });
        }
    };
};

/* SENDER USER */
export const notificationSenderUserStart = () => {
    return {
        type: actionTypes.NOTIFICATION_SENDER_USER_START
    }
};

export const notificationSenderUserSuccess = (user) => {
    return {
        type: actionTypes.NOTIFICATION_SENDER_USER_SUCCESS,
        user: user
    }
};

export const notificationSenderUserFail = (error) => {
    return {
        type: actionTypes.NOTIFICATION_SENDER_USER_FAIL,
        error: error
    }
};

export const getNotificationSenderUser = (id) => {
    return dispatch => {
        dispatch(notificationSenderUserStart());
        if(window.flow.getUserById) {
            window.flow.getUserById(id).then(res => {
                console.log('notification::getNotificationSenderUser');
                console.log(res);
                // dispatch to success
                dispatch(notificationSenderUserSuccess(res));
            }).catch(res => {
                // dispatch to error
                dispatch(notificationSenderUserFail(res));
            });
        }
    };
};
